import React from 'react';
import { Button, Modal } from 'react-bootstrap';

interface ConfirmationModalProps {
  show: boolean;
  discardAction: () => void;
  confirmAction: () => void;
  action: string;
}

const ConfirmationModal = ({ show, discardAction, confirmAction, action }: ConfirmationModalProps) => {
  return (
    <Modal show={show} onHide={discardAction} backdrop="static" keyboard={false} size="sm" centered>
      <Modal.Body className="text-center">{`Are you sure you want to ${action}?`}</Modal.Body>
      <Modal.Footer className="justify-content-center">
        <Button variant="secondary" onClick={discardAction}>
          No
        </Button>
        <Button variant="primary" onClick={confirmAction}>
          Yes
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmationModal;
